import React from 'react'
import { Container, Row, Col, Card, CardBody, Button, Spinner, ListGroup } from 'reactstrap';
import { database, storage } from '../firebase';
import update from 'immutability-helper';
import NavigationBar from '../components/NavigationBar';

class Listas extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      existeMais: true,
      items:[],
      params:{
        last:0,
        pageSize: 12,
      },
      festa: null,
      lista: {
        id: this.props.match.params.id !== null ? this.props.match.params.id : '',
        items:[]
      }
    }

    this.loadFesta = this.loadFesta.bind(this);
    this.updateMain = this.updateMain.bind(this);
  }

  componentDidMount() {
    if (this.state.lista.id !== null && this.state.lista.id !== '') {
      this.loadFesta(this.state.lista.id);
    }
  }

  loadFesta(id) {
    this.setState(state => update(state, {
      isLoading: {$set: true }
    }), () => {
      database.ref('festas').child(id).once('value', (snap) => {
        var festa = snap.val()

        this.setState(state => update(state, {
          festa: { $set: festa }
        }), () => {
            this.updateMain(festa);
        })
      }, (error) => {
        console.log(error)
      })
    })
  }

  updateMain(item) {
    const nome = (item.info.nome !== undefined && item.info.nome !== '') ? item.selo.info.nome + ' - ' + item.info.nome : item.selo.info.nome;
    const url = item.info.flyer;

    this.setState(state => update(state, {
      festa: { 
        nome: { $set: nome },
        url: { $set: url }
       },
      lista: {
        id: { $set: item.key }
      }
    }), () => {
        this.loadImage(url, 'festa-main');
        this.loadLista(item.key);
    })
  }

  loadLista(key) {
    this.setState(state => update(state, {
      isLoading: { $set: true }
    }), () => {
      var reference = database.ref("listas")
        .child(this.state.festa.key + "/nomes/").orderByValue().startAt('')

        reference.on('value', ((snap) => {
          if (snap.val()) {
            let dic = snap.val()

            var array = [];
            for (var key in dic) {
              array.push({
                key: key,
                value: dic[key]
              });
            }

            var sorted = array.sort(function (a, b) {
              return (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)
            });

            this.setState(state => update(state, {
              isLoading: { $set: false },
              lista:{
                items: { $set: sorted },
              }
            }))
          }
        }), ((error) => { console.log(error) }));
    })
  }

  checkLista(item) {
    const checked = item.value.checkin;
    const key = item.key;

    var json = null;

    if (checked === undefined || checked === null) {
      json = { nome: item.value, checkin: new Date().toISOString().substr(0, 19), key: key}
    }
    else {
      json = item.value.nome
    }

    database.ref('listas/' + this.state.lista.id + '/nomes/' + key).set(json, (error) => {
      if (!error) { }
    });
  }

  loadImage(path, id) {
    setTimeout(function () {
      const div = document.getElementById(id)
      if (path.includes('http') || path.includes('https')) {
        if (div !== null) div.innerHTML = "<img src='" + path + "' className='card-img-top' style='max-width:100%;' />";
      }
      else {
        storage.child(path).getDownloadURL().then(
          (url) => {
            if (div !== null) div.innerHTML = "<img src='" + url + "' className='card-img-top' style='max-width:100%;' />";
          },
          (error) => {
            console.log(error)
          });
      }
    }, 500);
  }

  render() {
    return (
      <React.Fragment>
        <NavigationBar /> {
          this.state.isLoading ?
            <Row className="pl-0 pr-0 ml-0 mr-0">
              <Col xs={12} className="text-center pl-0 pr-0 ml-0 mr-0" >
                <Button color="primary" style={{ margin: 0 + " auto", float: 'none' }} className="mb-1" disabled ><Spinner className="spinner-grow spinner-grow-sm"></Spinner> Carregando...</Button> 
              </Col>
            </Row>
          :
            <React.Fragment>
              <ListGroup className="col col-xs-12 col-sm-4 p-0 float-left p-1"> {
                this.state.festa !== null ?
                    <Card>
                      <div id="festa-main"></div>
                    </Card>
                  :
                    null
              }
              </ListGroup>
              <Col xs="12" sm="8" className="float-left pl-0 pr-0 ml-0 mr-0 p-1">
                <Container>{
                  this.state.lista.items.length > 0 ?
                    this.state.lista.items.map((item, i) => {
                      var nome = ""
                      
                      if (typeof item.value === 'string') {
                        nome = item.value;
                      }
                      else {
                        nome = item.value.nome;
                      }
                      var checked = false;
                      if (item.value.checkin !== undefined) {
                        checked = true;
                      }

                      return (
                        <Row key={i}>
                          <Col key={i} className="w-100 pl-0 pr-0">
                            <Card key={i} className="mb-1">
                              <CardBody className="p-3">
                                <p className="mb-0">{nome} {
                                  checked ?
                                    null 
                                  :
                                    null
                                } </p>
                                <Button key={i} style={{ position: 'absolute', right: 0, top: 0 }} className="m-2" color={checked ? "secondary" : "primary"} onClick={() => { this.checkLista(item); }}>{!checked ? "Confirmar" : "Cancelar"}</Button>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>)
                    })
                    :
                    <p>Este evento ainda não possui nome em sua lista</p>
                }
                </Container>
              </Col>
            </React.Fragment>
        }
      </React.Fragment>
    )
  }
}

export default (Listas)